import {ForgotPasswordSendToken} from 'domain/usecases';
import {RemoteForgotPasswordSendToken} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {EntryFlowEndPoints} from '../../endpoints';

export const makeForgotPasswordSendToken = (): ForgotPasswordSendToken =>
	new RemoteForgotPasswordSendToken(
		makeBFFApiUrl(EntryFlowEndPoints.forgotSendToken),
		makeAuthorizeHttpClientDecorator(),
	);
